import { reloadPage } from "~lib/browserNavigation.ts";

export async function resetAppData() {
  localStorage.clear();
  sessionStorage.clear();

  for (const cookie of document.cookie.split(";")) {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
    // biome-ignore lint/suspicious/noDocumentCookie: has to be done
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  }

  if (window.caches) {
    for (const key of await window.caches.keys()) {
      await window.caches.delete(key);
    }
  }

  if (navigator.serviceWorker) {
    for (const registration of await navigator.serviceWorker.getRegistrations()) {
      await registration.unregister();
    }
  }

  if (window.indexedDB) {
    for (const db of await window.indexedDB.databases()) {
      if (db.name) {
        window.indexedDB.deleteDatabase(db.name);
      }
    }
  }

  reloadPage();
}
